import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';
import RouterUtils from '../../../../../shared/routing/RouterUtils';

export class CompanyDetailRequest {

    _id; // number

    constructor(id) {
        this._id = id;
    }

    route() {
        return RouterUtils.generateRoute(ApiEndpoints.COMPANY_ID, { id: this._id });
    }
}



// WEBPACK FOOTER //
// ./src/app/my-company/company/form/update/company-detail/CompanyDetailRequest.js